import {Injectable, Injector} from "@angular/core";
import {SearchModel, SearchResult, SearchSortField} from "@fedeltapointofsale/data-client";
import {Observable} from "rxjs";

/**
 * Search model for Category
 */
@Injectable()
export class CategorySearchModel extends SearchModel<any> {

    private readonly COLUMN_COLLAPSED = "COLUMN_COLLAPSED";
    private readonly COLUMN_LEAF = "COLUMN_LEAF";

    private originalData: any[];

    private collapsedCategories: any[] = [];

    constructor(injector: Injector) {
        super(injector);

        this.pageable = false;

        this.$data.subscribe(() => {
            this.originalData = this.data.slice();
            this.setupData();
        });
    }

    override getIdentifierField(): string {
        return "categoryId";
    }

    setupData(): void {
        let previous: any;
        let level: number;

        this.data.splice(0);
        this.originalData.forEach((category) => {
            if (previous) {
                if (category.level <= previous.level && !previous[this.COLUMN_COLLAPSED]) {
                    previous[this.COLUMN_LEAF] = true;
                }
            }
            previous = category;

            if (level != undefined && category.level > level) {
                return;
            } else {
                this.data.push(category);
                if (this.collapsedCategories.find(value => value === category.categoryId) !== undefined) {
                    category[this.COLUMN_COLLAPSED] = true;
                    level = category.level;
                } else {
                    level = undefined;
                }
            }
        });
        if (previous) {
            previous[this.COLUMN_LEAF] = true;
        }

        this.dataView = {data: this.data, total: this.total, start: this.start, limit: this.limit, sort: this.sort};
        this.dataViewChange.next(this.dataView);
    }

    private getChildrenRange(category: any, array: any[]): any[] {
        const startIndex: number = array.findIndex(value => value === category);
        let endIndex: number;
        for (endIndex = startIndex + 1; endIndex < array.length; endIndex++) {
            if (array[endIndex].level <= category.level) {
                break;
            }
        }
        endIndex--;
        return [startIndex + 1, endIndex];
    }

    toggleCollapseCategory(category: any): void {
        if (this.isCollapsed(category)) {
            this.collapsedCategories = this.collapsedCategories.filter((item) => item !== category.categoryId);

            const range = this.getChildrenRange(category, this.originalData);

            const childrenData: any[] = this.originalData.slice(range[0], range[1] + 1);
            childrenData.forEach(value => value[this.COLUMN_COLLAPSED] = false);

            this.data.splice(this.data.findIndex(value => value === category) + 1, 0, ...childrenData);
        } else {
            this.collapsedCategories.push(category.categoryId);

            const range = this.getChildrenRange(category, this.data);
            this.data.splice(range[0], range[1] - range[0] + 1);
        }

        category[this.COLUMN_COLLAPSED] = !category[this.COLUMN_COLLAPSED];

        this.dataView = {data: this.data, total: this.total, start: this.start, limit: this.limit, sort: this.sort};
        this.dataViewChange.next(this.dataView);
    }

    hasChildren(category: any): boolean {
        return !category[this.COLUMN_LEAF];
    }

    isCollapsed(category: any): boolean {
        return category[this.COLUMN_COLLAPSED];
    }
}
